export const makeMenu = (hasQueries = false, selectedData = null, hasNps = false, npsField = null, selectedDisplay = null, hasSentiment = false, hasNumericFields = false, numericalFields = [], isZoomed = false, showingExpected = false, hasThemeGroups = false, featureFlags = {}) => {
    let options = featureFlags.theme_groups
        ? ['Themes', 'Theme Groups', 'Top Concepts', 'Top Phrases']
        : ['Themes', 'Top Concepts', 'Top Phrases'];
    const data_menu = {
        type: 'menu',
        title: 'Source',
        options: options.map(option => {
            if (option === 'Themes' && !hasQueries) {
                return {
                    label: 'Themes',
                    value: 'Themes',
                    disabled: true,
                    tooltip: 'There are no Themes added to this Dashboard',
                };
            }
            if (option === 'Theme Groups' && !hasThemeGroups) {
                return {
                    label: 'Theme Groups',
                    value: 'Theme Groups',
                    disabled: true,
                    tooltip: 'There are no Theme Groups in this Analysis',
                };
            }
            return option;
        }),
        showSelected: true,
        selected: selectedData,
    };
    let nps_menu = false;
    if (hasNps && npsField) {
        nps_menu = {
            type: 'menu',
            title: 'NPS',
            options: [
                { value: 'nps_', label: npsField }
            ],
            showSelected: true,
            selected: selectedDisplay
        };
    }
    if (showingExpected && nps_menu) {
        nps_menu.options.push({ value: 'npsi_', label: `Impact on ${npsField}` });
    }
    let sentiment_menu = false;
    if (hasSentiment) {
        sentiment_menu = {
            type: 'menu',
            title: 'Sentiment',
            options: [
                'Positive Sentiment', 'Negative Sentiment', 'Mixed Sentiment', 'Neutral Sentiment'
            ],
            showSelected: true,
            selected: selectedDisplay
        };
    }
    if (sentiment_menu && showingExpected) {
        sentiment_menu.options.push('', 'Impact on Positive Sentiment', 'Impact on Negative Sentiment', 'Impact on Mixed Sentiment', 'Impact on Neutral Sentiment');
    }
    const freq_menu = {
        type: 'menu',
        title: 'Frequency',
        options: showingExpected ? ['Frequency (%)', 'Frequency (#)'] : ['Frequency'],
        showSelected: true,
        selected: selectedDisplay
    };
    let numerics_menu = false;
    if (hasNumericFields) {
        numerics_menu = {
            type: 'menu',
            title: 'Numerical Field',
            options: [...numericalFields.map(nf => ({
                    label: `Avg. ${nf}`,
                    value: `__avg__${nf}`
                }))
            ],
            showSelected: true,
            selected: selectedDisplay
        };
    }
    if (numerics_menu && showingExpected) {
        numerics_menu.options.push('', ...numericalFields.map(nf => ({
            label: `Impact on Avg. ${nf}`,
            value: `__impact_on_avg__${nf}`
        })));
    }
    return [
        {
            name: 'Data',
            selection: selectedData,
            options: [[data_menu]],
        },
        {
            name: 'Display',
            selection: selectedDisplay,
            options: (isZoomed ? [
                // as one column
                [freq_menu, nps_menu, sentiment_menu, numerics_menu].filter(Boolean),
            ] : [
                // as three columns
                [freq_menu, nps_menu].filter(Boolean),
                [sentiment_menu].filter(Boolean),
                [numerics_menu].filter(Boolean),
            ])
                // remove empty sections
                .filter(o => o.length > 0),
        },
    ];
};
export const makeMenuCompare = (hasQueries = false, selectedData = null, hasNps = false, npsField = null, selectedDisplay = null, hasSentiment = false, hasNumericFields = false, numericalFields = [], isZoomed = false, hasThemeGroups = false, featureFlags = {}) => {
    const options = featureFlags.theme_groups
        ? ['Themes', 'Theme Groups', 'Top Concepts', 'Top Phrases']
        : ['Themes', 'Top Concepts', 'Top Phrases'];
    const dataMenu = {
        type: 'menu',
        title: 'Source',
        options: options.map((option) => {
            if (option === 'Themes' && !hasQueries) {
                return {
                    label: 'Themes',
                    value: 'Themes',
                    disabled: true,
                    tooltip: 'There are no Themes added to this Dashboard',
                };
            }
            if (option === 'Theme Groups' && !hasThemeGroups) {
                return {
                    label: 'Theme Groups',
                    value: 'Theme Groups',
                    disabled: true,
                    tooltip: 'There are no Theme Groups in this Analysis',
                };
            }
            return option;
        }),
        showSelected: true,
        selected: selectedData,
    };
    let npsMenu = false;
    if (hasNps && npsField) {
        npsMenu = {
            type: 'menu',
            title: 'NPS',
            options: [
                { value: 'nps_', label: npsField },
                { value: 'npsi_', label: `Impact on ${npsField}` },
            ],
            showSelected: true,
            selected: selectedDisplay,
        };
    }
    let sentimentMenu = false;
    if (hasSentiment) {
        sentimentMenu = {
            type: 'menu',
            title: 'Sentiment',
            options: [
                'Positive Sentiment',
                'Negative Sentiment',
                'Mixed Sentiment',
                'Neutral Sentiment',
            ],
            showSelected: true,
            selected: selectedDisplay,
        };
    }
    const freqMenu = {
        type: 'menu',
        title: 'Frequency',
        options: ['Frequency (%)', 'Frequency (#)'],
        showSelected: true,
        selected: selectedDisplay,
    };
    let numericsMenu = false;
    if (hasNumericFields) {
        numericsMenu = {
            type: 'menu',
            title: 'Numerical Field',
            options: [
                ...numericalFields.flatMap((nf) => [{
                        label: `Avg. ${nf}`,
                        value: `__avg__${nf}`,
                    }, {
                        label: `Impact on Avg. ${nf}`,
                        value: `__impact_on_avg__${nf}`
                    }])
            ],
            showSelected: true,
            selected: selectedDisplay,
        };
    }
    return [
        {
            name: 'Data',
            selection: selectedData,
            options: [[dataMenu]],
        },
        {
            name: 'Display',
            selection: selectedDisplay,
            options: (isZoomed ? [
                // as one column
                [freqMenu, npsMenu, sentimentMenu, numericsMenu].filter(Boolean),
            ] : [
                // as three columns
                [freqMenu, npsMenu].filter(Boolean),
                [sentimentMenu].filter(Boolean),
                [numericsMenu].filter(Boolean),
            ])
                // remove empty sections
                .filter(o => o.length > 0),
        },
    ];
};
